import { Box, Modal, Stack, Typography } from "@mui/material";
import { SmallModalStyle } from "../../../../styles/theme";
import { useCallback, useEffect, useState } from "react";

import {
  CustomButtonGray,
  CustomButtonYellow,
} from "../../../../styles/button";
import dayjs from "dayjs";
import { useMeetingRoom } from "../../../../hooks/MeetingRoom/useMeetingRoom";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../../azure/authConfig";
import { useOutlookDeeplink } from "../../../../hooks/Outlook/useOutlookDeepLink";
import { useRecoilValue } from "recoil";
import { MyDataAtom } from "../../../../system/atoms";
import { ErrorHandler } from "../../../../system/MeetingRoomApiService";
import AlertModal from "../../../Common/AlertModal";

type MeetingRoomEventDeleteModalProps = {
  modalInfo: {
    isOpen: boolean;
    selectedEvent: any;
  };
  handleIsOpen: (status: boolean) => void;
  refetchEventList: () => void;
};

const MeetingRoomEventModal = ({
  modalInfo,
  handleIsOpen,
  refetchEventList,
}: MeetingRoomEventDeleteModalProps) => {
  const { checkIsOrganizer } = useMeetingRoom();
  const { email } = useRecoilValue(MyDataAtom);
  const [targetWebLink, setTargetWebLink] = useState("");
  const { instance, accounts } = useMsal();
  const { openOutlookUpdateDeepLink } = useOutlookDeeplink();

  const getMyEvent = useCallback(async () => {
    try {
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      });

      const accessToken = response.accessToken;

      const { StartTime, EndTime } = modalInfo.selectedEvent;

      const start = dayjs(StartTime).format("YYYY-MM-DD");
      const end = dayjs(EndTime).format("YYYY-MM-DD");
      const url = `https://graph.microsoft.com/v1.0/me/calendarview?$top=1000&$skip=0&startdatetime=${start}T00:00:00.000Z&enddatetime=${end}T23:59:59.999Z`;

      const res = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Prefer: 'outlook.timezone = "Korea Standard Time"',
        },
      });

      const { value } = await res.json();

      const preData = value.slice(0).sort((a: any, b: any) => {
        return (
          new Date(a.start.dateTime).getTime() -
          new Date(b.start.dateTime).getTime()
        );
      });

      const targetInfo = preData.find(
        (el: any) => el.iCalUId === modalInfo.selectedEvent.icalUid
      );

      setTargetWebLink(targetInfo.webLink);
    } catch (error) {
      const msg = ErrorHandler(error);
      AlertModal("msg", msg);
    }
  }, [accounts, instance, modalInfo.selectedEvent]);

  const handleOpenUpdateDeepLink = useCallback(() => {
    openOutlookUpdateDeepLink(targetWebLink, refetchEventList);
    handleIsOpen(false);
  }, [
    targetWebLink,
    openOutlookUpdateDeepLink,
    handleIsOpen,
    refetchEventList,
  ]);

  useEffect(() => {
    if (
      accounts.length > 0 &&
      modalInfo.isOpen &&
      checkIsOrganizer(modalInfo.selectedEvent, email)
    ) {
      getMyEvent();
    }
  }, [accounts, getMyEvent, modalInfo, email, checkIsOrganizer]);

  return (
    <Modal open={modalInfo.isOpen} onClose={() => handleIsOpen(false)}>
      <Box sx={SmallModalStyle}>
        <Typography variant="subtitle1" fontWeight={600} mb={2}>
          예약 일정 확인
        </Typography>

        {modalInfo.selectedEvent && (
          <Stack spacing={1} mb={2}>
            <Typography variant="body2">
              <Typography component="span" variant="body2" fontWeight="bold">
                제목:
              </Typography>{" "}
              {modalInfo.selectedEvent.Subject}
            </Typography>
            <Typography variant="body2">
              <Typography component="span" variant="body2" fontWeight="bold">
                예약시간:
              </Typography>{" "}
              {dayjs(modalInfo.selectedEvent.StartTime).format("YYYY-MM-DD")}{" "}
              {dayjs(modalInfo.selectedEvent.StartTime).format("HH:mm")} ~{" "}
              {dayjs(modalInfo.selectedEvent.EndTime).format("HH:mm")}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              ※ '수정' 버튼 클릭 시, 즉시 해당 작업이 수행됩니다.
            </Typography>
          </Stack>
        )}
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          {email &&
          modalInfo.isOpen &&
          checkIsOrganizer(modalInfo.selectedEvent, email) ? (
            <CustomButtonYellow
              onClick={handleOpenUpdateDeepLink}
              sx={{ width: "60px", fontSize: "0.75rem", height: "2rem" }}
            >
              편집
            </CustomButtonYellow>
          ) : (
            <CustomButtonGray
              onClick={() => handleIsOpen(false)}
              sx={{ width: "60px", fontSize: "0.75rem", height: "2rem" }}
            >
              닫기
            </CustomButtonGray>
          )}
        </Stack>
      </Box>
    </Modal>
  );
};
export default MeetingRoomEventModal;
